import { LocalNotifications } from "@capacitor/local-notifications";
import getNotificationStatus from "./getNotificationStatus";
import { Preferences } from "@capacitor/preferences";

const removeNotificationsForTask = async (taskId) => {
  try {
    // Get list of notification associated with the task from preferences
    const deadlineNotifications = await getNotificationStatus(
      taskId,
      "deadline",
    );
    const scheduleNotifications = await getNotificationStatus(
      taskId,
      "schedule",
    );

    if (deadlineNotifications) {
      console.log("Cancelling deadline notifications for task:", taskId);
      // Cancel each notification
      await LocalNotifications.cancel({
        notifications: [
          { id: deadlineNotifications.nearlyDueNotificationId },
          { id: deadlineNotifications.overdueNotificationId },
        ],
      });

      // Remove notification status from preferences
      await Preferences.remove({
        key: `task_${taskId}_notifications_deadline`,
      });
    }

    if (scheduleNotifications) {
      console.log("Cancelling schedule notification for task:", taskId);
      // Cancel the notification
      await LocalNotifications.cancel({
        notifications: [{ id: scheduleNotifications.scheduleNotificationId }],
      });

      // Remove notification status from preferences
      await Preferences.remove({
        key: `task_${taskId}_notifications_schedule`,
      });
    }
  } catch (error) {
    // Silently handle errors (e.g., chunk loading failures when offline)
    // Notifications will be cleaned up on next app launch when online
    console.warn(
      "Failed to remove notifications for task:",
      taskId,
      error.message,
    );
  }
};

export default removeNotificationsForTask;
